import { ListUIItemInterface } from 'modules/ui/lists/BlockList/ListBlockUI/types';
import { FlowListInterface } from './types';

export const getFlowData = (data: FlowListInterface[]): ListUIItemInterface[] => {
  return data.map(({ type, title, meta, isProtected, image }) => ({ id: type, title, infoItem: meta, isProtected, image }));
};
